import React, { useCallback, useMemo } from 'react'
import VertRule from '../../images/VerticalRule.svg'
import withConfig from '../../wrappers/withConfig'
import { saveAs } from 'file-saver'

const JobOverview = ({ data, config }) => {
    const disclosureKey = useMemo(() => data.pKey, [data])
    const { DISCLOSURE_URL } = config

    const print = useCallback(
        () =>
            fetch(
                `${DISCLOSURE_URL}/${disclosureKey}/pdf`,
                {
                    headers: {
                        token: 'FbIg1hTgukBRfqwoMVBjjL5EvN1wzfD+3AsEMGps91kkMXZA+E8myU+3/zmZeyyypURTGA4i6vj8CUVN2tzf7w==',
                    },
                }
            )
                .then((res) => {
                    return res.blob()
                })
                .then(function (blob) {
                    saveAs(blob, 'Disclosure.pdf')
                }),
        [DISCLOSURE_URL, disclosureKey]
    )

    return (
        <>
            <div className="job_box">
                <img className="disclose_vr" src={VertRule}></img>
                <div className="job_details">
                    <p className="job">Job Completed: {data.JobEndDate}</p>
                    <p className="job">
                        Total Base Water Volume:{' '}
                        {data.TotalBaseWaterVolume != null
                            ? data.TotalBaseWaterVolume.toLocaleString('en-US')
                            : ''}
                    </p>
                    <p className="job">
                        Total Base Non-Water Volume:{' '}
                        {data.TotalBaseNonWaterVolume != null
                            ? data.TotalBaseNonWaterVolume.toLocaleString(
                                  'en-US'
                              )
                            : ''}
                    </p>
                    <p className="job">
                        True Vertical Depth:{' '}
                        {data.TVD != null
                            ? data.TVD.toLocaleString('en-US')
                            : ''}
                    </p>
                </div>
            </div>
            <div className="top">
                <h2 className="header_title">
                    Hydraulic Fracturing Fluid Composition
                </h2>
                <button onClick={print} className="pdf">
                    PDF Disclosure Form
                </button>
            </div>
        </>
    )
}

export default withConfig(JobOverview)
